import { render, staticRenderFns } from "./items_book_endless.vue?vue&type=template&id=0c28dfef"
import script from "./items_book_endless.vue?vue&type=script&lang=js"
export * from "./items_book_endless.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SeoTitle: require('/home/ubuntu/containers/hermes_eshop/components/core/seoTitle.vue').default,ItemsHeader: require('/home/ubuntu/containers/hermes_eshop/components/core/itemsHeader.vue').default,FilterPanel: require('/home/ubuntu/containers/hermes_eshop/components/core/filterPanel.vue').default,Product: require('/home/ubuntu/containers/hermes_eshop/components/core/product.vue').default,ItemsPagination: require('/home/ubuntu/containers/hermes_eshop/components/core/itemsPagination.vue').default})
